import { Row } from "./lazyExcel";
import { ImportedField, normalizeHeader } from "./parse";

export const checkFirstRowForHeaders = <R, T>(row: Row, iFields: ImportedField<R, T>[]) => {
  if (!row.values) {
    throw new Error("First row has no header data");
  }
  (row.values as any[]).forEach((val: any) => {
    if (typeof val !== "string") {
      throw new Error("Headers must be strings");
    }
  });

  const columns = (row.values as string[]).filter((h: string) => h !== "").map(normalizeHeader);

  iFields.forEach(({ fields, required }) => {
    if (required && !fields.some(f => columns.some(c => c === normalizeHeader(f as string)))) {
      throw new Error(`Missing required header *${fields.join(",")}*`);
    }
  });
};
